import { render } from "./ContentPublishHistory.vue?vue&type=template&id=2c0108b1&ts=true"
import script from "./ContentPublishHistory.vue?vue&type=script&lang=ts"
export * from "./ContentPublishHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__